import { Component, OnInit } from '@angular/core';

interface WindowWithHelpSystem extends Window {
  datex_flyout_config?: {
    url: string;
  },
  datexHelpFlyout?: {
    toggle(): void;
  };
}

@Component({
  selector: 'datex-help-button',
  templateUrl: './help-button.component.html',
  styleUrls: ['./help-button.component.scss'],
  standalone: false
})
export class HelpButtonComponent {
  private readonly scriptId = 'datex-help-studio-script';
  private readonly scriptSrc = 'https://help.datexstudio.com/flyout.js';
  private isLoading = false;

  constructor() { }

  private get window(): WindowWithHelpSystem {
    return window;
  }

  private get ready(): boolean {
    return !!document.getElementById(this.scriptId)
      && this.window.datex_flyout_config !== undefined
      && typeof this.window.datex_flyout_config.url === "string"
      && this.window.datexHelpFlyout !== undefined
      && typeof this.window.datexHelpFlyout.toggle === "function";
  }

  async toggle(): Promise<void> {
    if (!this.ready) {
      await this.setup();
      await this.ensureLoaded();
    }

    this.window.datexHelpFlyout?.toggle();
  }

  private async ensureLoaded(): Promise<void> {
    while (!this.ready) {
      await new Promise(resolve => setTimeout(resolve, 50));
    }
  }

  private setup(): Promise<void> {
    if (this.isLoading) {
      return Promise.resolve();
    }

    this.isLoading = true;
    this.window.datex_flyout_config = {
      url: 'https://help.datexstudio.com/studio-help-navigator.html'
    };

    const script = document.createElement('script');
    script.id = this.scriptId;
    script.src = this.scriptSrc;
    document.body.appendChild(script);

    return new Promise<void>((resolve, reject) => {
      script.onload = () => { this.isLoading = false; resolve(); };
      script.onerror = () => { this.isLoading = false; reject(new Error('Failed to load help flyout script.')); };
    });
  }
}